import React from 'react';
import {
  deferTracking,
  sendGAEvent,
  sendGALinkClickEvent,
} from '@noths/polaris-client-google-analytics';
import {
  type BreadcrumbLinkClickPayload,
  Breadcrumbs,
} from '@noths/polaris-design-system-candidate-components';

import { buildBreadcrumbClickEvent } from 'src/components/molecules/Breadcrumbs/breadcrumbClickEvent';
import {
  isSoftNavigableHref,
  TaxonomyBreadcrumbLink,
} from 'src/components/molecules/Breadcrumbs/TaxonomyBreadcrumbLink';
import { useTaxonomyBreadcrumbs } from 'src/components/molecules/Breadcrumbs/useTaxonomyBreadcrumbs';

export const TaxonomyBreadcrumbsContainer = () => {
  const links = useTaxonomyBreadcrumbs();

  const onLinkClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    { linkDepth }: BreadcrumbLinkClickPayload,
  ) => {
    const anchor = e.currentTarget;
    const event = buildBreadcrumbClickEvent({ destinationURL: anchor.href, linkDepth });

    // A soft transition keeps the page alive, so the event can be pushed off the
    // interaction's critical path and navigation must not be intercepted.
    // Crumbs that leave the app still have to record before the browser unloads.
    if (isSoftNavigableHref(anchor.getAttribute('href') ?? undefined)) {
      deferTracking(() => {
        sendGAEvent(event);
      });

      return;
    }

    sendGALinkClickEvent(e, event);
  };

  if (!links || links.length === 0) {
    return null;
  }

  return (
    <Breadcrumbs
      as={TaxonomyBreadcrumbLink}
      includesCurrentPage
      links={links}
      onLinkClick={onLinkClick}
    />
  );
};
